import Tabs from "../UI/Tabs/Tabs";
import TabsItem from "../UI/Tabs/TabsItem";
import { useAuth } from "../../contexts/AuthContext";

export default (props) => {
  const { currentUser } = useAuth();
  const userID = props.userID ? props.userID : currentUser.uid;

  return (
    <Tabs>
      {userID == currentUser.uid && (
        <TabsItem to="/profile/contracts" activeClassName="Tabs__item_state_active">
          Задания
        </TabsItem>
      )}
      <TabsItem to={`${userID !== currentUser.uid  ? "/users/" + userID : "/profile"}` } activeClassName="Tabs__item_state_active">
        Профиль
      </TabsItem>
      <TabsItem to={`${userID !== currentUser.uid  ? "/users/skills/" + userID : "/profile/skills"}` } activeClassName="Tabs__item_state_active">
        Навыки
      </TabsItem>
    </Tabs>
  );
};
